import Swal from "sweetalert2";

export default function notificationError(error: any) {
    Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.data?.message || error?.message || error?.data?.originalError?.info?.message || "Not connected to server"
    })
}